import { FC, ReactNode, useEffect, useMemo, useRef, useState } from 'react'
import { FlagsmithProvider } from '@flagsmith/flagsmith/react'
import flagsmith from '@flagsmith/flagsmith/isomorphic'
import { Project } from 'common/project'
import { useUser } from 'common/services/useUser'
import Loader from 'components/base/Loader'

type FeatureFlagProviderType = {
  children?: ReactNode
}

const FeatureFlagProvider: FC<FeatureFlagProviderType> = ({ children }) => {
  const [_, setReady] = useState(Date.now())

  const { data } = useUser({})
  const username = data?.email
  const loadingState = flagsmith.loadingState
  const ready = useMemo(() => loadingState?.source !== 'NONE', [loadingState])
  useEffect(() => {
    if (!ready) return
    if (flagsmith.identity !== username) {
      if (username) {
        flagsmith.identify(username, {
          email: username,
        })
      } else {
        flagsmith.logout()
      }
    }
  }, [username, ready])

  const flagsmithOptions = useRef({
    cacheFlags: true,
    environmentID: Project.flagsmith,
    identity: username,
    onChange: () => {
      if (flagsmith.loadingState?.source !== 'NONE') {
        setTimeout(() => setReady(Date.now()), 0)
      }
    },
    traits: data ? { email: data?.email } : undefined,
  })

  return (
    <FlagsmithProvider options={flagsmithOptions.current} flagsmith={flagsmith}>
      {!ready ? (
        <div className='text-center'>
          <Loader />
        </div>
      ) : (
        <>{children}</>
      )}
    </FlagsmithProvider>
  )
}

export default FeatureFlagProvider
